import { render, staticRenderFns } from "./print_IUL.vue?vue&type=template&id=0c644c5f&scoped=true"
import script from "./print_IUL.vue?vue&type=script&lang=js"
export * from "./print_IUL.vue?vue&type=script&lang=js"
import style0 from "./print_IUL.vue?vue&type=style&index=0&id=0c644c5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c644c5f",
  null
  
)

export default component.exports